// extracted by mini-css-extract-plugin
export default {"inlineBetInfo":"styles_inlineBetInfo__ZNCGe","inlineBetInfo__line":"styles_inlineBetInfo__line__WzkDY","selectionName":"styles_selectionName__KEpkH"};